//common
import React from "react";
import helper from "../../../../helper/helper";
const columns = ({downFile} = {}) =>
  [
    {
      title: "#",
      dataIndex: "stt",
      width: "45px",
      align: 'center'
    },
    {
      title: "Tài liệu",
      dataIndex: "tenTaiLieu",
      defaultSortOrder: "descend",
      render: (value, row) => (<a onClick={() => downFile(row)}>{row.tenTaiLieu}</a>),
      width: "35%",
    },
    {
      title: "Số tài liệu",
      dataIndex: "soTaiLieu",
      width: "30%",
    },
    {
      title: "Ngày ký",
      dataIndex: "ngayKy",
      render: (value, row) => (helper.formatTableDate(row.ngayKy))
    },
  ].map(col => ({ ...col}));

export default columns;
